var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSecureServerAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3056",
    "data-name": "Rectangle 3056",
    width: 24,
    height: 24,
    transform: "translate(1588 1369)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_secure_server_access",
    transform: "translate(-1588 -1369)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8903",
    "data-name": "Group 8903",
    transform: "translate(1588.773 1369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_237",
    "data-name": "Union 237",
    d: "M.522,10.423A.532.532,0,0,1,0,9.883V4.821A.532.532,0,0,1,.522,4.28H.952V3.622A3.561,3.561,0,0,1,4.441,0a3.562,3.562,0,0,1,3.49,3.622V4.28h.431a.532.532,0,0,1,.521.541V9.883a.532.532,0,0,1-.521.541ZM3.92,6.8V7.9a.522.522,0,1,0,1.043,0V6.8a.522.522,0,1,0-1.043,0ZM6.888,4.28V3.622a2.5,2.5,0,0,0-2.447-2.54,2.5,2.5,0,0,0-2.447,2.54V4.28Z",
    transform: "translate(13.572 13.577)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_162",
    "data-name": "Subtraction 162",
    d: "M12.586,22.883H1.478A1.4,1.4,0,0,1,0,21.57v-4.5a1.4,1.4,0,0,1,1.478-1.313h12.3a5.251,5.251,0,0,0-.187,1.126H1.478a.2.2,0,0,0-.212.187v4.5a.2.2,0,0,0,.212.188H12.586v1.124Zm-6.4-2.813a.75.75,0,1,1,.751-.75A.751.751,0,0,1,6.189,20.07Zm-2.625,0a.75.75,0,1,1,.75-.75A.751.751,0,0,1,3.564,20.07Zm10.487-5.064H1.478A1.4,1.4,0,0,1,0,13.693v-4.5A1.4,1.4,0,0,1,1.478,7.879h19a1.4,1.4,0,0,1,1.477,1.313v4.5a1.181,1.181,0,0,1-.144.565,3.4,3.4,0,0,0-1.123-1.049V9.192A.2.2,0,0,0,20.474,9h-19a.2.2,0,0,0-.212.187v4.5a.2.2,0,0,0,.212.188H14.835a3.955,3.955,0,0,0-.784,1.124Zm4.337-2.813h-4.5a.75.75,0,0,1,0-1.5h4.5a.75.75,0,1,1,0,1.5Zm-12.2,0a.75.75,0,1,1,.751-.75A.751.751,0,0,1,6.189,12.192Zm-2.625,0a.75.75,0,1,1,.75-.75A.751.751,0,0,1,3.564,12.192Zm16.91-5.065h-19A1.4,1.4,0,0,1,0,5.814v-4.5A1.4,1.4,0,0,1,1.478,0h19a1.4,1.4,0,0,1,1.477,1.313v4.5A1.4,1.4,0,0,1,20.474,7.127Zm-19-6a.2.2,0,0,0-.212.187v4.5A.2.2,0,0,0,1.478,6h19a.2.2,0,0,0,.211-.188v-4.5a.2.2,0,0,0-.211-.187Zm16.91,3.188h-4.5a.75.75,0,0,1,0-1.5h4.5a.75.75,0,1,1,0,1.5Zm-12.2,0a.75.75,0,1,1,.751-.75A.751.751,0,0,1,6.189,4.314Zm-2.625,0a.75.75,0,1,1,.75-.75A.751.751,0,0,1,3.564,4.314Z",
    transform: "translate(0 0)",
    fill: "#003fb9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecureServerAccess);
export default __webpack_public_path__ + "static/media/ic_secure_server_access.0fb4c40680b9e27527633daf5dbf9058.svg";
export { ForwardRef as ReactComponent };